import { Injectable, inject } from '@angular/core';
import { HttpClient } from '@angular/common/http';

import { FeedOutBaseService } from './feedout-base.service';

@Injectable()
export class FeedOutService extends FeedOutBaseService {
  constructor() {
    const http = inject(HttpClient);

    super(http);
  }
}
